import { inject, Injectable } from '@angular/core';
import { L10nTranslationService } from 'angular-l10n';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private readonly translation = inject(L10nTranslationService);

  translateDuration(
    duration: number,
    short?: boolean,
    concatHoursAndMinutes?: boolean
  ): string {
    let result = '';

    const days = Math.floor(duration / 1440);
    duration -= days * 1440;
    if (days) {
      result += short
        ? this.translation.translate('COMMON.DATES.days_short', {
            counter: days,
          })
        : this.translation.translate(`COMMON.DATES.day${days > 1 ? 's' : ''}`, {
            counter: days,
          });
    }

    let hours: number;
    let minutes: number;
    if (!concatHoursAndMinutes) {
      hours = Math.floor(duration / 60);
      duration -= hours * 60;
      if (hours) {
        result = this.parseHours(result, short, hours);
      }

      minutes = duration % 60;
      if (minutes) {
        result +=
          (result ? ' ' : '') +
          (short
            ? this.translation.translate('COMMON.DATES.mins_short', {
                counter: minutes,
              })
            : this.translation.translate(
                `COMMON.DATES.min${minutes > 1 ? 's' : ''}`,
                { counter: minutes }
              ));
      }
      return result;
    }

    hours = Math.floor(duration / 60);
    duration -= hours * 60;
    minutes = duration % 60;

    if (!minutes) {
      result = this.parseHours(result, short, hours);
      return result;
    } else {
      result +=
        (result ? ' ' : '') +
        (hours
          ? this.translation.translate(
              `COMMON.DATES.hour${hours > 1 ? 's' : ''}`,
              {
                counter: `${hours}:${minutes}`,
              }
            )
          : this.translation.translate(
              `COMMON.DATES.min${minutes > 1 ? 's' : ''}`,
              { counter: minutes }
            ));
    }

    return result;
  }

  parseHours(result: string, short: boolean, hours: number) {
    result += short
      ? this.translation.translate('COMMON.DATES.hours_short', {
          counter: hours,
        })
      : (result ? ' ' : '') +
        this.translation.translate(`COMMON.DATES.hour${hours > 1 ? 's' : ''}`, {
          counter: hours,
        });
    return result;
  }
}
